import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ApprenticeshipsIntro() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Apprenticeships Introduction
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Building Your Future Through Quality Training
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section id="apprenticeships-intro" className="apprenticeships-intro section" style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <h3 style={{ color: '#7B3F9E', fontSize: '2.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      APPRENTICES @ DTK
                    </h3>
                    <div style={{ width: '80px', height: '4px', backgroundColor: '#7B3F9E', margin: '0 auto', borderRadius: '2px' }}></div>
                  </div>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Apprenticeships are a style of learning programme which allows individuals to combine work and study by blending on-the-job training with more customary teaching methods - distance learning online or face-to-face classroom delivery.
                  </p>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Apprenticeships are not only for new employees or school leavers who are new to the job; or an employer with current staff you'd like to encourage and develop, anyone can complete an Apprenticeship at any age and any moment in their careers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-4">
                  <h3 style={{ color: '#7B3F9E', fontSize: '2rem', fontWeight: '700', marginBottom: '15px' }}>
                    An Apprenticeship Could Be Right For You
                  </h3>
                </div>
                
                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="p-4 h-100 shadow-sm" style={{
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      border: '2px solid #7B3F9E',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                    }}>
                      <div className="text-center mb-3">
                        <div style={{
                          width: '70px',
                          height: '70px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto'
                        }}>
                          <span style={{ fontSize: '2rem' }}>💰</span>
                        </div>
                      </div>
                      <h5 className="text-center mb-3" style={{ color: '#7B3F9E', fontWeight: '600' }}>
                        Earn While You Learn
                      </h5>
                      <p className="text-center mb-0" style={{ color: '#475569', lineHeight: '1.7' }}>
                        No drop in income - get paid while gaining valuable qualifications
                      </p>
                    </div>
                  </div>
                  
                  <div className="col-md-4">
                    <div className="p-4 h-100 shadow-sm" style={{
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      border: '2px solid #7B3F9E',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                    }}>
                      <div className="text-center mb-3">
                        <div style={{
                          width: '70px',
                          height: '70px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto'
                        }}>
                          <span style={{ fontSize: '2rem' }}>📚</span>
                        </div>
                      </div>
                      <h5 className="text-center mb-3" style={{ color: '#7B3F9E', fontWeight: '600' }}>
                        Flexible Learning
                      </h5>
                      <p className="text-center mb-0" style={{ color: '#475569', lineHeight: '1.7' }}>
                        Choose from workplace or hybrid learning options that suit your lifestyle
                      </p>
                    </div>
                  </div>
                  
                  <div className="col-md-4">
                    <div className="p-4 h-100 shadow-sm" style={{
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      border: '2px solid #7B3F9E',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                    }}>
                      <div className="text-center mb-3">
                        <div style={{
                          width: '70px',
                          height: '70px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto'
                        }}>
                          <span style={{ fontSize: '2rem' }}>📈</span>
                        </div>
                      </div>
                      <h5 className="text-center mb-3" style={{ color: '#7B3F9E', fontWeight: '600' }}>
                        Career Progression
                      </h5>
                      <p className="text-center mb-0" style={{ color: '#475569', lineHeight: '1.7' }}>
                        Improve and progress in your role with industry-recognized qualifications
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Apprenticeships provide you with real work experience whilst studying for a qualification that has been devised by employers to make sure it gives them the most current skills and motivating career possibilities. Apprenticeships usually take between one and four years to complete, subject to some factors such as the level, sector, employer requests and individual ability.
                  </p>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Apprentices will learn both on and off the job to gain the skills, knowledge and procedures required in the workplace.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Levels Table Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-4">
                  <h3 style={{ color: '#7B3F9E', fontSize: '2rem', fontWeight: '700', marginBottom: '15px' }}>
                    Apprenticeship Levels
                  </h3>
                  <p style={{ color: '#475569', fontSize: '1.05rem' }}>
                    Choose the level that matches your career goals
                  </p>
                </div>
                
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <thead style={{ backgroundColor: '#7B3F9E' }}>
                        <tr>
                          <th style={{ color: '#7B3F9E', padding: '20px 30px', fontWeight: '600', border: 'none' }}>Type of Apprenticeship</th>
                          <th style={{ color: '#7B3F9E', padding: '20px 30px', fontWeight: '600', border: 'none' }}>Level</th>
                          <th style={{ color: '#7B3F9E', padding: '20px 30px', fontWeight: '600', border: 'none' }}>Equivalent Education Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', color: '#334155', fontWeight: '500' }}>Intermediate</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>2</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>GCSE</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
                          <td style={{ padding: '20px 30px', color: '#334155', fontWeight: '500' }}>Advanced</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>3</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>A level</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', color: '#334155', fontWeight: '500' }}>Higher</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>4, 5</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>Foundation Degree</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f8fafc' }}>
                          <td style={{ padding: '20px 30px', color: '#334155', fontWeight: '500' }}>Degree</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>6, 7</td>
                          <td style={{ padding: '20px 30px', color: '#334155' }}>Bachelors (6) or Master's degree (7)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* DTK Method Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <h3 style={{ color: '#7B3F9E', fontSize: '2.2rem', fontWeight: '700', marginBottom: '15px' }}>
                      Apprenticeships at DTK
                    </h3>
                    <div style={{ width: '80px', height: '4px', backgroundColor: '#7B3F9E', margin: '0 auto', borderRadius: '2px' }}></div>
                  </div>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    The DTK method details our modern approach to delivering Apprenticeships and describes our continued responsibility to the delivery of excellent performance and professional standards. From our initial engagement with our employer partners through to the Apprentices' work, progression, and destination interview, we ensure that each Apprentice experiences a remarkable learning journey and that their development considerably enhances our employer's performance and output.
                  </p>
                  
                  <div className="p-4" style={{
                    backgroundColor: '#F5EBFA',
                    borderRadius: '16px',
                    borderLeft: '4px solid #7B3F9E'
                  }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', fontWeight: '500' }}>
                      At DTK, we consider that all our learners, staff and employers are entitled to good quality Apprenticeship service that can be offered. We define the 'best' as excellence in every aspect of the apprenticeship journey.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ApprenticeshipsIntro;